var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForConnectingV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 432,
    viewBox: "0 0 420 432",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2770_96012)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416,
    width: 2,
    height: 2,
    transform: "rotate(90 416 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    width: 2,
    height: 2,
    transform: "rotate(90 406 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    width: 2,
    height: 2,
    transform: "rotate(90 396 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    width: 2,
    height: 2,
    transform: "rotate(90 386 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    width: 2,
    height: 2,
    transform: "rotate(90 376 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    width: 2,
    height: 2,
    transform: "rotate(90 366 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    width: 2,
    height: 2,
    transform: "rotate(90 356 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    width: 2,
    height: 2,
    transform: "rotate(90 346 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    width: 2,
    height: 2,
    transform: "rotate(90 336 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    width: 2,
    height: 2,
    transform: "rotate(90 326 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    width: 2,
    height: 2,
    transform: "rotate(90 316 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    width: 2,
    height: 2,
    transform: "rotate(90 306 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    width: 2,
    height: 2,
    transform: "rotate(90 296 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    width: 2,
    height: 2,
    transform: "rotate(90 286 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    width: 2,
    height: 2,
    transform: "rotate(90 276 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    width: 2,
    height: 2,
    transform: "rotate(90 266 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    width: 2,
    height: 2,
    transform: "rotate(90 256 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    width: 2,
    height: 2,
    transform: "rotate(90 246 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    width: 2,
    height: 2,
    transform: "rotate(90 236 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    width: 2,
    height: 2,
    transform: "rotate(90 226 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    width: 2,
    height: 2,
    transform: "rotate(90 216 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    width: 2,
    height: 2,
    transform: "rotate(90 206 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    width: 2,
    height: 2,
    transform: "rotate(90 196 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    width: 2,
    height: 2,
    transform: "rotate(90 186 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    width: 2,
    height: 2,
    transform: "rotate(90 176 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    width: 2,
    height: 2,
    transform: "rotate(90 166 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    width: 2,
    height: 2,
    transform: "rotate(90 156 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    width: 2,
    height: 2,
    transform: "rotate(90 146 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    width: 2,
    height: 2,
    transform: "rotate(90 136 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    width: 2,
    height: 2,
    transform: "rotate(90 126 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    width: 2,
    height: 2,
    transform: "rotate(90 116 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    width: 2,
    height: 2,
    transform: "rotate(90 106 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    width: 2,
    height: 2,
    transform: "rotate(90 96 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    width: 2,
    height: 2,
    transform: "rotate(90 86 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    width: 2,
    height: 2,
    transform: "rotate(90 76 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    width: 2,
    height: 2,
    transform: "rotate(90 66 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    width: 2,
    height: 2,
    transform: "rotate(90 56 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    width: 2,
    height: 2,
    transform: "rotate(90 46 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    width: 2,
    height: 2,
    transform: "rotate(90 36 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    width: 2,
    height: 2,
    transform: "rotate(90 26 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    width: 2,
    height: 2,
    transform: "rotate(90 16 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    width: 2,
    height: 2,
    transform: "rotate(90 6 0)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 416 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 406 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 396 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 386 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 376 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 366 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 356 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 346 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 336 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 326 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 316 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 306 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 296 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 286 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 276 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 266 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 256 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 246 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 236 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 226 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 216 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 206 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 196 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 186 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 176 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 166 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 156 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 146 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 136 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 126 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 116 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 106 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 96 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 86 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 76 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 66 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 56 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 46 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 36 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 26 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 16 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 6 10)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 416 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 406 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 396 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 386 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 376 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 366 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 356 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 346 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 336 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 326 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 316 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 306 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 296 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 286 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 276 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 266 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 256 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 246 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 236 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 226 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 216 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 206 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 196 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 186 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 176 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 166 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 156 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 146 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 136 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 126 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 116 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 106 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 96 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 86 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 76 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 66 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 56 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 46 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 36 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 26 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 16 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 20,
    width: 2,
    height: 2,
    transform: "rotate(90 6 20)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 416 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 406 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 396 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 386 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 376 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 366 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 356 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 346 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 336 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 326 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 316 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 306 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 296 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 286 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 276 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 266 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 256 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 246 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 236 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 226 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 216 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 206 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 196 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 186 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 176 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 166 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 156 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 146 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 136 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 126 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 116 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 106 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 96 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 86 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 76 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 66 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 56 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 46 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 36 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 26 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 16 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 30,
    width: 2,
    height: 2,
    transform: "rotate(90 6 30)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 416 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 406 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 396 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 386 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 376 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 366 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 356 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 346 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 336 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 326 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 316 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 306 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 296 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 286 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 276 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 266 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 256 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 246 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 236 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 226 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 216 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 206 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 196 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 186 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 176 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 166 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 156 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 146 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 136 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 126 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 116 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 106 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 96 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 86 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 76 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 66 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 56 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 46 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 36 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 26 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 16 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 40,
    width: 2,
    height: 2,
    transform: "rotate(90 6 40)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 416 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 406 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 396 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 386 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 376 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 366 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 356 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 346 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 336 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 326 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 316 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 306 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 296 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 286 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 276 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 266 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 256 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 246 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 236 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 226 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 216 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 206 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 196 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 186 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 176 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 166 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 156 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 146 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 136 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 126 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 116 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 106 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 96 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 86 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 76 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 66 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 56 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 46 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 36 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 26 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 16 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 50,
    width: 2,
    height: 2,
    transform: "rotate(90 6 50)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 416 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 406 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 396 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 386 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 376 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 366 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 356 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 346 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 336 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 326 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 316 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 306 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 296 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 286 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 276 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 266 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 256 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 246 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 236 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 226 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 216 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 206 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 196 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 186 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 176 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 166 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 156 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 146 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 136 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 126 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 116 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 106 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 96 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 86 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 76 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 66 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 56 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 46 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 36 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 26 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 16 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 60,
    width: 2,
    height: 2,
    transform: "rotate(90 6 60)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 416 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 406 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 396 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 386 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 376 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 366 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 356 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 346 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 336 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 326 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 316 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 306 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 296 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 286 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 276 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 266 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 256 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 246 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 236 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 226 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 216 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 206 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 196 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 186 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 176 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 166 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 156 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 146 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 136 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 126 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 116 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 106 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 96 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 86 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 76 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 66 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 56 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 46 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 36 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 26 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 16 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 70,
    width: 2,
    height: 2,
    transform: "rotate(90 6 70)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 416 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 406 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 396 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 386 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 376 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 366 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 356 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 346 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 336 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 326 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 316 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 306 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 296 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 286 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 276 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 266 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 256 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 246 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 236 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 226 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 216 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 206 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 196 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 186 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 176 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 166 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 156 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 146 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 136 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 126 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 116 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 106 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 96 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 86 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 76 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 66 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 56 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 46 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 36 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 26 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 16 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 80,
    width: 2,
    height: 2,
    transform: "rotate(90 6 80)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 416 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 406 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 396 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 386 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 376 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 366 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 356 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 346 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 336 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 326 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 316 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 306 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 296 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 286 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 276 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 266 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 256 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 246 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 236 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 226 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 216 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 206 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 196 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 186 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 176 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 166 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 156 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 146 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 136 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 126 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 116 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 106 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 96 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 86 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 76 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 66 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 56 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 46 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 36 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 26 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 16 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 90,
    width: 2,
    height: 2,
    transform: "rotate(90 6 90)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 416 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 406 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 396 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 386 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 376 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 366 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 356 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 346 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 336 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 326 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 316 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 306 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 296 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 286 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 276 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 266 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 256 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 246 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 236 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 226 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 216 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 206 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 196 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 186 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 176 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 166 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 156 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 146 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 136 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 126 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 116 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 106 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 96 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 86 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 76 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 66 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 56 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 46 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 36 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 26 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 16 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 100,
    width: 2,
    height: 2,
    transform: "rotate(90 6 100)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 416 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 406 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 396 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 386 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 376 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 366 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 356 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 346 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 336 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 326 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 316 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 306 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 296 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 286 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 276 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 266 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 256 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 246 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 236 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 226 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 216 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 206 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 196 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 186 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 176 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 166 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 156 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 146 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 136 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 126 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 116 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 106 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 96 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 86 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 76 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 66 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 56 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 46 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 36 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 26 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 16 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 110,
    width: 2,
    height: 2,
    transform: "rotate(90 6 110)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 416 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 406 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 396 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 386 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 376 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 366 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 356 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 346 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 336 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 326 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 316 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 306 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 296 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 286 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 276 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 266 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 256 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 246 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 236 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 226 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 216 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 206 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 196 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 186 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 176 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 166 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 156 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 146 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 136 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 126 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 116 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 106 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 96 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 86 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 76 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 66 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 56 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 46 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 36 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 26 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 16 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 120,
    width: 2,
    height: 2,
    transform: "rotate(90 6 120)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 416 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 406 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 396 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 386 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 376 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 366 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 356 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 346 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 336 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 326 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 316 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 306 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 296 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 286 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 276 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 266 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 256 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 246 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 236 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 226 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 216 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 206 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 196 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 186 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 176 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 166 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 156 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 146 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 136 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 126 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 116 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 106 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 96 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 86 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 76 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 66 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 56 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 46 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 36 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 26 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 16 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 130,
    width: 2,
    height: 2,
    transform: "rotate(90 6 130)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 416 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 406 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 396 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 386 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 376 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 366 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 356 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 346 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 336 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 326 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 316 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 306 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 296 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 286 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 276 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 266 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 256 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 246 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 236 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 226 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 216 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 206 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 196 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 186 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 176 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 166 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 156 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 146 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 136 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 126 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 116 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 106 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 96 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 86 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 76 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 66 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 56 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 46 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 36 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 26 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 16 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 140,
    width: 2,
    height: 2,
    transform: "rotate(90 6 140)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 416 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 406 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 396 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 386 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 376 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 366 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 356 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 346 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 336 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 326 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 316 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 306 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 296 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 286 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 276 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 266 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 256 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 246 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 236 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 226 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 216 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 206 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 196 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 186 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 176 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 166 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 156 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 146 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 136 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 126 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 116 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 106 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 96 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 86 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 76 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 66 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 56 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 46 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 36 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 26 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 16 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 150,
    width: 2,
    height: 2,
    transform: "rotate(90 6 150)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 416 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 406 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 396 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 386 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 376 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 366 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 356 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 346 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 336 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 326 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 316 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 306 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 296 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 286 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 276 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 266 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 256 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 246 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 236 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 226 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 216 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 206 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 196 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 186 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 176 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 166 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 156 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 146 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 136 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 126 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 116 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 106 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 96 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 86 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 76 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 66 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 56 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 46 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 36 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 26 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 16 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 160,
    width: 2,
    height: 2,
    transform: "rotate(90 6 160)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 416 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 406 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 396 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 386 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 376 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 366 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 356 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 346 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 336 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 326 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 316 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 306 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 296 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 286 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 276 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 266 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 256 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 246 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 236 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 226 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 216 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 206 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 196 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 186 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 176 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 166 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 156 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 146 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 136 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 126 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 116 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 106 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 96 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 86 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 76 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 66 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 56 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 46 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 36 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 26 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 16 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 170,
    width: 2,
    height: 2,
    transform: "rotate(90 6 170)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 416 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 406 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 396 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 386 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 376 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 366 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 356 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 346 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 336 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 326 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 316 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 306 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 296 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 286 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 276 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 266 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 256 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 246 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 236 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 226 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 216 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 206 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 196 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 186 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 176 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 166 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 156 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 146 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 136 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 126 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 116 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 106 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 96 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 86 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 76 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 66 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 56 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 46 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 36 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 26 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 16 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 180,
    width: 2,
    height: 2,
    transform: "rotate(90 6 180)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 416 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 406 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 396 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 386 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 376 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 366 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 356 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 346 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 336 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 326 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 316 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 306 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 296 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 286 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 276 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 266 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 256 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 246 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 236 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 226 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 216 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 206 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 196 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 186 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 176 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 166 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 156 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 146 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 136 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 126 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 116 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 106 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 96 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 86 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 76 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 66 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 56 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 46 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 36 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 26 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 16 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 190,
    width: 2,
    height: 2,
    transform: "rotate(90 6 190)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 416 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 406 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 396 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 386 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 376 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 366 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 356 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 346 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 336 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 326 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 316 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 306 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 296 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 286 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 276 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 266 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 256 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 246 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 236 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 226 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 216 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 206 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 196 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 186 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 176 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 166 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 156 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 146 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 136 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 126 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 116 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 106 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 96 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 86 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 76 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 66 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 56 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 46 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 36 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 26 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 16 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 200,
    width: 2,
    height: 2,
    transform: "rotate(90 6 200)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 416 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 406 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 396 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 386 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 376 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 366 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 356 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 346 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 336 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 326 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 316 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 306 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 296 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 286 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 276 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 266 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 256 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 246 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 236 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 226 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 216 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 206 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 196 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 186 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 176 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 166 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 156 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 146 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 136 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 126 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 116 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 106 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 96 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 86 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 76 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 66 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 56 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 46 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 36 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 26 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 16 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 210,
    width: 2,
    height: 2,
    transform: "rotate(90 6 210)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 416 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 406 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 396 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 386 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 376 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 366 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 356 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 346 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 336 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 326 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 316 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 306 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 296 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 286 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 276 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 266 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 256 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 246 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 236 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 226 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 216 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 206 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 196 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 186 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 176 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 166 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 156 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 146 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 136 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 126 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 116 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 106 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 96 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 86 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 76 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 66 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 56 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 46 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 36 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 26 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 16 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 220,
    width: 2,
    height: 2,
    transform: "rotate(90 6 220)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 416 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 406 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 396 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 386 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 376 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 366 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 356 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 346 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 336 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 326 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 316 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 306 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 296 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 286 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 276 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 266 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 256 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 246 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 236 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 226 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 216 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 206 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 196 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 186 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 176 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 166 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 156 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 146 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 136 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 126 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 116 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 106 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 96 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 86 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 76 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 66 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 56 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 46 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 36 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 26 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 16 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 230,
    width: 2,
    height: 2,
    transform: "rotate(90 6 230)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 416 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 406 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 396 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 386 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 376 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 366 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 356 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 346 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 336 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 326 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 316 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 306 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 296 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 286 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 276 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 266 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 256 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 246 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 236 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 226 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 216 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 206 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 196 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 186 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 176 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 166 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 156 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 146 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 136 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 126 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 116 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 106 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 96 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 86 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 76 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 66 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 56 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 46 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 36 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 26 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 16 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 240,
    width: 2,
    height: 2,
    transform: "rotate(90 6 240)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 416 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 406 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 396 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 386 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 376 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 366 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 356 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 346 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 336 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 326 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 316 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 306 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 296 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 286 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 276 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 266 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 256 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 246 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 236 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 226 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 216 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 206 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 196 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 186 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 176 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 166 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 156 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 146 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 136 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 126 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 116 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 106 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 96 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 86 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 76 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 66 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 56 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 46 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 36 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 26 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 16 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 250,
    width: 2,
    height: 2,
    transform: "rotate(90 6 250)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 416 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 406 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 396 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 386 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 376 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 366 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 356 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 346 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 336 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 326 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 316 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 306 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 296 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 286 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 276 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 266 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 256 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 246 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 236 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 226 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 216 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 206 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 196 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 186 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 176 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 166 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 156 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 146 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 136 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 126 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 116 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 106 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 96 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 86 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 76 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 66 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 56 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 46 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 36 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 26 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 16 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 260,
    width: 2,
    height: 2,
    transform: "rotate(90 6 260)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 416 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 406 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 396 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 386 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 376 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 366 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 356 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 346 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 336 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 326 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 316 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 306 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 296 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 286 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 276 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 266 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 256 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 246 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 236 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 226 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 216 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 206 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 196 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 186 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 176 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 166 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 156 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 146 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 136 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 126 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 116 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 106 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 96 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 86 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 76 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 66 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 56 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 46 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 36 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 26 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 16 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 270,
    width: 2,
    height: 2,
    transform: "rotate(90 6 270)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 416 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 406 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 396 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 386 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 376 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 366 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 356 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 346 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 336 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 326 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 316 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 306 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 296 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 286 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 276 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 266 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 256 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 246 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 236 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 226 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 216 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 206 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 196 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 186 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 176 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 166 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 156 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 146 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 136 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 126 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 116 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 106 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 96 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 86 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 76 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 66 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 56 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 46 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 36 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 26 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 16 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 280,
    width: 2,
    height: 2,
    transform: "rotate(90 6 280)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 416 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 406 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 396 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 386 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 376 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 366 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 356 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 346 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 336 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 326 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 316 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 306 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 296 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 286 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 276 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 266 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 256 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 246 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 236 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 226 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 216 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 206 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 196 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 186 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 176 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 166 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 156 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 146 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 136 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 126 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 116 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 106 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 96 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 86 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 76 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 66 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 56 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 46 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 36 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 26 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 16 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 290,
    width: 2,
    height: 2,
    transform: "rotate(90 6 290)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 416 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 406 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 396 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 386 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 376 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 366 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 356 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 346 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 336 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 326 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 316 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 306 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 296 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 286 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 276 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 266 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 256 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 246 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 236 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 226 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 216 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 206 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 196 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 186 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 176 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 166 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 156 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 146 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 136 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 126 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 116 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 106 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 96 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 86 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 76 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 66 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 56 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 46 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 36 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 26 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 16 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 300,
    width: 2,
    height: 2,
    transform: "rotate(90 6 300)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 416 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 406 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 396 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 386 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 376 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 366 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 356 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 346 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 336 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 326 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 316 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 306 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 296 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 286 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 276 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 266 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 256 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 246 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 236 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 226 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 216 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 206 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 196 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 186 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 176 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 166 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 156 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 146 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 136 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 126 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 116 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 106 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 96 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 86 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 76 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 66 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 56 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 46 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 36 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 26 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 16 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 310,
    width: 2,
    height: 2,
    transform: "rotate(90 6 310)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 416 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 406 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 396 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 386 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 376 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 366 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 356 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 346 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 336 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 326 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 316 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 306 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 296 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 286 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 276 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 266 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 256 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 246 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 236 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 226 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 216 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 206 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 196 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 186 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 176 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 166 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 156 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 146 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 136 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 126 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 116 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 106 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 96 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 86 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 76 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 66 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 56 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 46 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 36 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 26 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 16 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 320,
    width: 2,
    height: 2,
    transform: "rotate(90 6 320)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 416 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 406 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 396 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 386 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 376 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 366 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 356 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 346 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 336 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 326 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 316 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 306 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 296 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 286 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 276 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 266 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 256 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 246 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 236 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 226 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 216 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 206 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 196 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 186 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 176 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 166 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 156 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 146 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 136 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 126 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 116 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 106 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 96 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 86 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 76 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 66 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 56 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 46 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 36 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 26 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 16 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 330,
    width: 2,
    height: 2,
    transform: "rotate(90 6 330)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 416 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 406 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 396 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 386 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 376 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 366 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 356 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 346 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 336 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 326 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 316 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 306 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 296 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 286 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 276 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 266 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 256 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 246 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 236 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 226 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 216 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 206 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 196 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 186 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 176 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 166 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 156 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 146 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 136 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 126 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 116 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 106 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 96 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 86 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 76 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 66 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 56 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 46 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 36 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 26 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 16 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 340,
    width: 2,
    height: 2,
    transform: "rotate(90 6 340)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 416 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 406 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 396 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 386 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 376 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 366 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 356 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 346 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 336 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 326 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 316 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 306 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 296 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 286 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 276 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 266 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 256 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 246 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 236 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 226 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 216 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 206 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 196 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 186 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 176 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 166 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 156 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 146 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 136 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 126 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 116 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 106 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 96 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 86 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 76 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 66 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 56 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 46 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 36 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 26 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 16 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 350,
    width: 2,
    height: 2,
    transform: "rotate(90 6 350)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 416 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 406 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 396 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 386 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 376 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 366 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 356 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 346 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 336 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 326 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 316 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 306 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 296 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 286 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 276 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 266 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 256 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 246 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 236 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 226 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 216 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 206 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 196 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 186 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 176 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 166 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 156 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 146 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 136 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 126 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 116 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 106 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 96 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 86 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 76 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 66 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 56 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 46 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 36 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 26 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 16 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 360,
    width: 2,
    height: 2,
    transform: "rotate(90 6 360)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 416 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 406 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 396 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 386 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 376 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 366 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 356 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 346 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 336 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 326 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 316 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 306 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 296 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 286 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 276 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 266 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 256 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 246 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 236 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 226 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 216 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 206 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 196 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 186 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 176 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 166 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 156 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 146 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 136 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 126 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 116 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 106 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 96 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 86 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 76 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 66 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 56 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 46 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 36 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 26 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 16 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 370,
    width: 2,
    height: 2,
    transform: "rotate(90 6 370)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 416 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 406 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 396 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 386 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 376 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 366 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 356 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 346 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 336 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 326 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 316 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 306 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 296 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 286 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 276 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 266 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 256 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 246 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 236 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 226 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 216 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 206 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 196 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 186 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 176 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 166 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 156 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 146 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 136 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 126 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 116 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 106 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 96 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 86 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 76 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 66 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 56 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 46 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 36 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 26 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 16 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 380,
    width: 2,
    height: 2,
    transform: "rotate(90 6 380)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 416 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 406 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 396 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 386 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 376 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 366 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 356 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 346 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 336 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 326 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 316 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 306 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 296 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 286 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 276 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 266 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 256 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 246 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 236 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 226 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 216 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 206 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 196 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 186 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 176 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 166 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 156 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 146 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 136 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 126 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 116 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 106 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 96 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 86 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 76 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 66 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 56 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 46 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 36 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 26 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 16 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 390,
    width: 2,
    height: 2,
    transform: "rotate(90 6 390)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 416 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 406 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 396 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 386 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 376 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 366 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 356 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 346 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 336 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 326 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 316 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 306 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 296 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 286 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 276 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 266 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 256 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 246 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 236 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 226 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 216 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 206 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 196 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 186 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 176 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 166 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 156 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 146 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 136 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 126 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 116 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 106 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 96 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 86 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 76 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 66 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 56 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 46 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 36 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 26 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 16 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 400,
    width: 2,
    height: 2,
    transform: "rotate(90 6 400)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 416 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 406 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 396 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 386 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 376 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 366 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 356 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 346 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 336 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 326 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 316 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 306 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 296 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 286 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 276 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 266 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 256 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 246 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 236 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 226 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 216 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 206 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 196 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 186 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 176 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 166 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 156 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 146 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 136 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 126 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 116 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 106 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 96 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 86 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 76 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 66 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 56 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 46 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 36 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 26 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 16 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 410,
    width: 2,
    height: 2,
    transform: "rotate(90 6 410)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 416 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 406 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 396 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 386 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 376 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 366 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 356 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 346 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 336 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 326 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 316 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 306 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 296 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 286 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 276 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 266 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 256 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 246 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 236 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 226 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 216 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 206 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 196 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 186 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 176 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 166 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 156 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 146 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 136 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 126 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 116 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 106 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 96 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 86 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 76 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 66 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 56 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 46 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 36 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 26 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 16 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 420,
    width: 2,
    height: 2,
    transform: "rotate(90 6 420)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 416 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 406 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 396 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 386 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 376 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 366 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 356 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 346 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 336 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 326 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 316 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 306 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 296 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 286 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 276 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 266 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 256 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 246 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 236 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 226 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 216 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 206 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 196 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 186 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 176 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 166 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 156 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 146 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 136 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 126 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 116 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 106 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 96 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 86 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 76 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 66 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 56 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 46 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 36 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 26 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 16 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 430,
    width: 2,
    height: 2,
    transform: "rotate(90 6 430)",
    fill: "currentColor",
    fillOpacity: 0.12
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2770_96012"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 432,
    height: 420,
    fill: "currentColor",
    transform: "translate(420) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForConnectingV2);
export default __webpack_public_path__ + "static/media/for-connecting-v2.2dc50cb3064f728c1e3e0784a3b5838f.svg";
export { ForwardRef as ReactComponent };